import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Heart, Star, ShieldCheck, Sparkles, ArrowRight } from "lucide-react";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";
import AppointmentForm from "../components/home/AppointmentForm";
import NeedSupport from "../components/NeedSupport";
import Reveal from "../components/Reveal";

const features = [
  { icon: Heart, title: "Compassionate Care" },
  { icon: Star, title: "Personalized Attention" },
  { icon: ShieldCheck, title: "Trusted Expertise" },
  { icon: Sparkles, title: "Effortless Experience" },
];

const Appointment = () => {
  useEffect(() => {
    document.title = "Appointment – Moggies & Doggies Veterinary Care";
  }, []);
  return (
    <div className="min-h-screen bg-white font-body text-pawelle-body">
      <SiteHeader />
      <main>
        <PageBanner
          title="Appointment"
          subtitle="Book Your Pet's Comprehensive Wellness Appointment Now"
          crumbs={["Appointment"]}
        />

        <section className="mx-auto max-w-[1290px] px-5 py-16 md:py-20">
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {features.map((f, i) => {
              const Icon = f.icon;
              return (
                <Reveal key={f.title} animation="fadeInUp" delay={i * 90} className="group rounded-[28px] bg-pawelle-bg p-8 transition-all duration-300 hover:bg-pawelle-primary">
                  <div className="flex h-14 w-14 items-center justify-center rounded-full bg-white text-pawelle-primary transition-colors group-hover:bg-white/15 group-hover:text-white">
                    <Icon className="h-7 w-7" />
                  </div>
                  <h3 className="mt-5 font-display text-[19px] font-semibold text-pawelle-ink transition-colors group-hover:text-white">{f.title}</h3>
                </Reveal>
              );
            })}
          </div>
        </section>

        <AppointmentForm />
        <NeedSupport />
      </main>
      <Footer />
    </div>
  );
};

export default Appointment;
